"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groceryCategoryNameToPositionMap = void 0;
const enumStrings_1 = require("./enumStrings");
exports.groceryCategoryNameToPositionMap = {
    [enumStrings_1.GC_RECIPE_LINKS]: 1,
    [enumStrings_1.GC_UNCATEGORIZED]: 999,
    "Home and Outdoor": 22,
    "Baby and Kids": 25,
    "Baking Ingredients": 16,
    "Cereal and Breakfast": 15,
    Produce: 2,
    "Health and Beauty": 24,
    Seafood: 3,
    Dairy: 18,
    "Misc.": 27,
    "Rice, Grains, and Dried Beans": 10,
    Meats: 5,
    "Spices and Seasonings": 7,
    "Oils, Vinegars, and Dressings": 12,
    Beverages: 20,
    "Canned and Jar Goods": 13,
    "Frozen Foods": 19,
    Pasta: 14,
    "Pet Products": 26,
    Snacks: 17,
    "Bulk Bin": 8,
    "Deli and Prepared Foods": 4,
    "Everyday Essentials": 23,
    "Bakery and Bread": 6,
    "International Foods": 11,
    "Sauces and Condiments": 9,
    "Beer, Wine, and Spirits": 21,
};
//# sourceMappingURL=groceryCategoryNameToPosition.js.map